import { Typography, Box, Button } from "@mui/material"
import { useHistory } from "react-router"
import LockIcon from "@mui/icons-material/Lock"
import BlockIcon from "@mui/icons-material/Block"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import bannerGuardiao from "../assets/bannerGuardiao.jpg"
import commandsProvider from "../providers/CommandsProvider";

export default function UserNotAllowed(props) {
    const history = useHistory();

    const session = commandsProvider.getSession();
    const licenseType = session.getLicenseType();
    const isLicenseValid = session.isLicenseValid();

    const isFree = licenseType === "Free";
    const isInvalid = licenseType === "Invalida" || licenseType === "Inválida";
    const isTechnicianWithInvalidLicense = licenseType === "Tecnico" && !isLicenseValid;
    const isLicenseIssue = isFree || isInvalid || isTechnicianWithInvalidLicense;

    if (isLicenseIssue) {
        return (
            <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 3, px: 2 }}>
                <Box
                    component="img"
                    src={bannerGuardiao}
                    alt="Banner Guardião"
                    sx={{ maxWidth: "600px", width: "100%", borderRadius: "16px", boxShadow: "0 8px 32px rgba(0,0,0,0.3)" }}
                />
                <Typography variant="h6" sx={{ color: "rgba(255,255,255,0.7)", textAlign: "center", maxWidth: "500px" }}>
                    {isInvalid
                        ? "Licença inválida. Entre em contato com o suporte."
                        : "Recurso não disponível na versão Free."
                    }
                </Typography>
                <Button
                    variant="outlined"
                    startIcon={<ArrowBackIcon />}
                    onClick={() => history.goBack()}
                    sx={{
                        borderColor: "rgba(255,255,255,0.3)",
                        color: "rgba(255,255,255,0.7)",
                        textTransform: "none",
                        "&:hover": { borderColor: "rgba(255,255,255,0.6)", background: "rgba(255,255,255,0.05)" }
                    }}
                >
                    Voltar
                </Button>
            </Box>
        );
    }

    return (
        <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 3, px: 2 }}>
            <Box sx={{
                background: "linear-gradient(135deg, rgba(26,37,47,0.97) 0%, rgba(44,62,80,0.97) 100%)",
                border: "2px solid rgba(231,76,60,0.4)",
                borderRadius: "20px",
                padding: "3rem 3.5rem",
                maxWidth: "520px",
                width: "100%",
                textAlign: "center",
                boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 2
            }}>
                <Box sx={{
                    width: 72,
                    height: 72,
                    borderRadius: "50%",
                    background: "rgba(231,76,60,0.15)",
                    border: "2px solid rgba(231,76,60,0.4)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}>
                    {props.userRole?.usuarios === false
                        ? <BlockIcon sx={{ fontSize: 36, color: "#E74C3C" }} />
                        : <LockIcon sx={{ fontSize: 36, color: "#E74C3C" }} />
                    }
                </Box>
                <Typography variant="h5" sx={{ color: "#fff", fontWeight: 700 }}>
                    Acesso Negado
                </Typography>
                <Typography variant="body1" sx={{ color: "rgba(255,255,255,0.65)", lineHeight: 1.6 }}>
                    Seu usuário não possui permissão para acessar esta funcionalidade.
                </Typography>
                <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.4)", fontSize: "0.82rem" }}>
                    Solicite ao administrador do sistema as permissões necessárias.
                </Typography>
                <Button
                    variant="contained"
                    startIcon={<ArrowBackIcon />}
                    onClick={() => history.goBack()}
                    sx={{
                        mt: 1,
                        borderRadius: "10px",
                        background: "rgba(231,76,60,0.15)",
                        border: "1px solid rgba(231,76,60,0.4)",
                        color: "#E74C3C",
                        fontWeight: 600,
                        textTransform: "none",
                        boxShadow: "none",
                        "&:hover": { background: "rgba(231,76,60,0.25)", boxShadow: "0 4px 12px rgba(231,76,60,0.2)" }
                    }}
                >
                    Voltar
                </Button>
            </Box>
        </Box>
    );
}
